import type { CSSProperties } from 'react'

/**
 * Cores reais da marca por ambiente (fonte: TEXA Hub antigo, AMB_COLOR).
 * CAR na marca é branco (#FFFFFF); no app usamos prata para funcionar no tema
 * claro. Os demais são os hex exatos da marca.
 */
export const AMBIENTE_HEX: Record<string, string> = {
  GERAL: '#64748b',
  CAR: '#94a3b8', // prata (marca = branco)
  BIKE: '#e63946',
  TRUCK: '#4a90e2',
  OHW: '#f5c518',
  MARINE: '#14b8a6',
  KONFORT: '#b8b8c0',
  TEXAEDU: '#22c55e',
}

export const TEXA_NAVY = '#012269'
export const TEXA_GOLD = '#d4af37'

export function frenteHex(frente: string | null | undefined): string {
  return (frente ? AMBIENTE_HEX[frente] : undefined) ?? '#64748b'
}

/** Estilo de borda-esquerda por ambiente (padrão visual do hub antigo). */
export function frenteBorderStyle(frente: string | null | undefined): CSSProperties {
  return { borderLeftColor: frenteHex(frente), borderLeftWidth: 3 }
}
